import React from "react";
import imageUrl from "utils/imageUrl";
function BuyPropGallery() {
  return (
    <section className="p__gallery wow fadeInUp" id="gallery">
      <div className="container">
        <hr className="divider" />
        <div className="p__gallery__area section__space">
          <div className="title__with__cta">
            <div className="row d-flex align-items-center">
              <div className="col-lg-8">
                <h2>Property Gallery</h2>
              </div>
            </div>
          </div>
          <div className="row p__gallery__single">
            <div className="col-md-6 col-lg-4 gallery__single__two">
              <a href={imageUrl("gallery/one.png")} target={"_blank"}>
                <img src={imageUrl("gallery/one.png")} alt="Property Image" />
              </a>
            </div>
            <div className="col-md-6 col-lg-4 gallery__single__two">
              <a href={imageUrl("gallery/two.png")} target={"_blank"}>
                <img src={imageUrl("gallery/two.png")} alt="Property Image" />
              </a>
            </div>
            <div className="col-md-6 col-lg-4 gallery__single__two">
              <a href={imageUrl("gallery/three.png")} target={"_blank"}>
                <img src={imageUrl("gallery/three.png")} alt="Property Image" />
              </a>
            </div>
            <div className="col-md-6 col-lg-4 gallery__single__two">
              <a href={imageUrl("gallery/four.png")} target={"_blank"}>
                <img src={imageUrl("gallery/four.png")} alt="Property Image" />
              </a>
            </div>
            <div className="col-md-6 col-lg-4 gallery__single__two">
              <a href={imageUrl("gallery/five.png")} target={"_blank"}>
                <img src={imageUrl("gallery/five.png")} alt="Property Image" />
              </a>
            </div>
            <div className="col-md-6 col-lg-4 gallery__single__two">
              <a href={imageUrl("gallery/six.png")} target={"_blank"}>
                <img src={imageUrl("gallery/six.png")} alt="Property Image" />
              </a>
            </div>
            <div className="col-md-6 col-lg-4 gallery__single__two">
              <a href={imageUrl("gallery/seven.png")} target={"_blank"}>
                <img src={imageUrl("gallery/seven.png")} alt="Property Image" />
              </a>
            </div>
            <div className="col-md-6 col-lg-4 gallery__single__two">
              <a href={imageUrl("gallery/eight.png")} target={"_blank"}>
                <img src={imageUrl("gallery/eight.png")} alt="Property Image" />
              </a>
            </div>
            <div className="col-md-6 col-lg-4 gallery__single__two">
              <a href={imageUrl("gallery/nine.png")} target={"_blank"}>
                <img src={imageUrl("gallery/nine.png")} alt="Property Image" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BuyPropGallery;
